import { useState, useContext, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Button,
  Dialog,
  TextField,
  Typography,
  DialogContent,
  Checkbox,
  Stack,
} from "@mui/material";
import { useMutation } from "@apollo/client";
//Import from project
import "../../../Style/dialogstyle.scss";
import { AuthContext } from "../../../Context/AuthContext";
import { DialogTitleComp } from "../../../Utils/Component";
import {
  CREATE_COUNCIL_POSITION,
  UPDATE_COUNCIL_POSITION,
} from "../../../Schema/CouncilPositions";

export default function CouncilPositionsForm({
  open,
  onChange = () => { }, 
  editData,
  setRefetch,
  handleClose,
  dialogTitle,
  hideBackdrop,
}) {
  // Change Language
  const { t, setAlert, language } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [createCouncilPositions] = useMutation(CREATE_COUNCIL_POSITION, {
    onCompleted: ({ createCouncilPositions }) => {
      setLoading(false);
      if (createCouncilPositions?.isSuccess === true) {

        console.log("createCouncilPositions :", createCouncilPositions)
        if (onChange) {
          onChange({
            id: createCouncilPositions?.data?._id,
            title: language === "en" ? createCouncilPositions?.data?.positionsNameEng || createCouncilPositions?.data?.positionsNameKh : createCouncilPositions?.data?.positionsNameKh || createCouncilPositions?.data?.positionsNameEng
          })
        }

        setAlert(true, "success", createCouncilPositions?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createCouncilPositions?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateCouncilPositions] = useMutation(UPDATE_COUNCIL_POSITION, {
    onCompleted: ({ updateCouncilPositions }) => {
      setLoading(false);
      if (updateCouncilPositions?.isSuccess === true) {
        setAlert(true, "success", updateCouncilPositions?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateCouncilPositions?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    isDefault: Yup.boolean().required(t("required")),
    positionsNameKh: Yup.string().required(t("required")),
    positionsNameEng: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      isDefault: false,
      positionsNameKh: "",
      positionsNameEng: "",
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      if (dialogTitle === "Create") {
        createCouncilPositions({
          variables: {
            input: {
              ...values,
            },
          },
        });
      } else {
        updateCouncilPositions({
          variables: {
            id: editData?._id,
            input: {
              ...values,
            },
          },
        });
      }
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("isDefault", editData?.isDefault);
      setFieldValue("positionsNameKh", editData?.positionsNameKh);
      setFieldValue("positionsNameEng", editData?.positionsNameEng);
    }
  }, [editData, open]);

  return (
    <Dialog
      fullWidth
      open={open}
      maxWidth="xs"
      className="dialog-container"
      hideBackdrop={hideBackdrop}
    >
      <DialogTitleComp
        title={
          dialogTitle === "Create"
            ? t("modal_title_create_council_positions")
            : t("modal_title_update_council_positions")
        }
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>

              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_positions_name")}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("thead_positions_name")}
                  {...getFieldProps("positionsNameKh")}
                  error={Boolean(
                    touched.positionsNameKh && errors.positionsNameKh
                  )}
                  helperText={touched.positionsNameKh && errors.positionsNameKh}
                />
              </Grid>


              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_positions_name")} (English)
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  className="text-field"
                  placeholder={t("thead_positions_name")}
                  {...getFieldProps("positionsNameEng")}
                  error={Boolean(
                    touched.positionsNameEng && errors.positionsNameEng
                  )}
                  helperText={
                    touched.positionsNameEng && errors.positionsNameEng
                  }
                />
              </Grid>

              <Grid item xs={12}>
                <Stack direction="row" alignItems="center" >
                  <Checkbox
                    checked={values?.isDefault}
                    onChange={({ target }) => setFieldValue("isDefault", Boolean(target?.checked))}
                  />
                  <Typography className={t("class-name-field-title")} sx={{ marginTop: 1 }}>
                    {t("thead_default")}
                  </Typography>
                </Stack>
              </Grid>

              <Grid item xs={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className={t("class-btn-create")}
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {t("create")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
